import React, { useState, useEffect } from 'react';
//import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row, Table } from "react-bootstrap";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const UiCompAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [uiCompAttrs, setUiCompAttrs] = useState({
    id: '',
    name: '',
    description: '',
    typeId: '',
    config: '',
    dataList: '',
    dataSrcStyle: '',
    dataLenStyle: '',
    attrList: '',
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });


/*
  const chartTypeList = [
    { key: "LINE_CHART", value: "LINE_CHART" },
    { key: "BAR_CHART",  value: "BAR_CHART" },
    { key: "AREA_CHART", value: "AREA_CHART" }
  ];
*/

  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');

  const [uiCompTypeList, setUiCompTypeList] = useState([]);

  //const [selectedCompType, setSelectedCompType] = useState({});
  const [typeSpecificAttrs, setTypeSpecificAttrs] = useState([]);

  const [dataObjList, setDataObjList] = useState([]);

  //const [chartType, setChartType] = useState('');

  // Ui Functions

  const fetchCompTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-comp-types");

        resolve(res.data);

        if (res.status === 200) {
          setUiCompTypeList(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  // Initialize state
  useEffect(() => {

    if (props) {
      setUiCompAttrs(props.objDetails);

      if (props.objDetails) {

        let tmpConfig = JSON.parse(props.objDetails.config);

        setTypeSpecificAttrs(tmpConfig);

        let tmpDataObjList = [];
        let start = 0;

        if (props.objDetails.dataList && (props.objDetails.dataList != null) && (props.objDetails.dataList.length > 0)) {
          tmpDataObjList = JSON.parse(props.objDetails.dataList);
          start = tmpDataObjList.length;
        }

        for (let i=0; i<start; i++) {
          tmpDataObjList[i].id = i;
        }

        for (let i=start; i<10; i++) {
          tmpDataObjList.push ({id:   i,
                                code: '',
                                name: '',
                                color: ''});
        }

        setDataObjList (tmpDataObjList);
      }
    }

    fetchCompTypes();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setUiCompAttrs({ ...uiCompAttrs, [e.target.name]: e.target.value })
  }


/*
  const onTypeSpecificAttrsInputChange = (e) => {
    setTypeSpecificAttrs({ ...typeSpecificAttrs, [e.target.name]: e.target.value })
  }

  const onChartTypeSelect = (key, event) => {
    //setChartType(key);
    setTypeSpecificAttrs({ ...typeSpecificAttrs, 'chartType': key })
  };
*/

/*
  const onDataObjListChange = (e) => {
    setDataObjList (e.target.value);
  }
*/

/*
  const onDataObjInputChange = (index, e) => {
    let tmpList = JSON.parse(JSON.stringify(dataObjList));
    tmpList[index][e.target.name] = e.target.value;

    setDataObjList(tmpList);
  }
*/

  const onCompTypeSelect = (key, event) => {

    let newCompType = uiCompTypeList.find( ({ id }) => id === parseInt(key) );

    // Update all UI comp type related attributes for the uiCompAttr
    let tmpUiCompAttr = JSON.parse(JSON.stringify(uiCompAttrs));

    tmpUiCompAttr.typeId       = newCompType.id;
    tmpUiCompAttr.dataLenStyle = newCompType.dataLenStyle;
    tmpUiCompAttr.dataSrcStyle = newCompType.dataSrcStyle;

    setUiCompAttrs(tmpUiCompAttr);

    // Other updates
    //setSelectedCompType (newCompType);

    if (newCompType && newCompType.attrList) {
      let tmpArray = newCompType.attrList.split(',');
      let tmpAttrList = {}

      for (let i=0; i<tmpArray.length; i++) {
        tmpAttrList[tmpArray[i]] = '';
      }

      setTypeSpecificAttrs (tmpAttrList);
    }
  };


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setUiCompAttrs(props.objDetails);

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    const reqBody = JSON.parse(JSON.stringify(uiCompAttrs));;

    // Compose configuration attributes
    let tmpConfig = JSON.parse(JSON.stringify(typeSpecificAttrs));

    reqBody.config = JSON.stringify(tmpConfig);

    if (uiCompAttrs.dataSrcStyle === 'FIXED') {

      let tmpDataList = [];

      for (let i=0; i<dataObjList.length; i++) {
        if (dataObjList[i].name && dataObjList[i].name !== '')
          tmpDataList.push(dataObjList[i]);
      }

      reqBody.dataList = JSON.stringify(tmpDataList);
    }


    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("ui-comps/" + uiCompAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore Ui to viewing mode
          setEditMode(false);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


/*
  function renderTypeSpecificAttrs(attrName, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>
          <Row>
            <Col>{attrName}</Col>
            {editMode ?
              <Col>
                { attrName === 'chartType' ?
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={((!typeSpecificAttrs['chartType']) || (typeSpecificAttrs['chartType'] === "")) ? t("common:I18N_DROPDOWN_PROMPT") : typeSpecificAttrs['chartType']}
                    onSelect={onChartTypeSelect}>
                    {chartTypeList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {item.value}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                :
                  <input className={classes.admin_pages__field_editable} name={attrName} value={typeSpecificAttrs[attrName]}
                    onChange={(e) => onTypeSpecificAttrsInputChange(e)} />
                }
              </Col>
            :
              <Col className={classes.admin_pages__field_value}>{typeSpecificAttrs[attrName]}</Col>
            }
            <Col></Col>
            <Col></Col>
          </Row>
        </td>
      </tr>
    )
  }


  function renderDataObj(dataObj, index) {
    if (editMode || (dataObj.code !== '')) {
      return (
        <tr key={index} style={{fontWeight:'300'}}>
          <td>
            <Row>
               { editMode ?
                <>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name='code' value={dataObj.code}
                      onChange={(e) => onDataObjInputChange(index, e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name='name' value={dataObj.name}
                      onChange={(e) => onDataObjInputChange(index, e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name='color' value={dataObj.color}
                      onChange={(e) => onDataObjInputChange(index, e)} />
                  </Col>
                </>
              :
                <>
                  <Col>{dataObj.code}</Col>
                  <Col>{dataObj.name}</Col>
                  <Col>{dataObj.color}</Col>
                </>
               }
              <Col></Col>
            </Row>
          </td>
        </tr>
      )
    }
  }
*/


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_UiComp_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_UiComp_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_UiComp_name")}: *</Col>
                  <Col>{t("I18N_Description")}:</Col>
                  <Col>{t("I18N_UiComp_type")}: *</Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>{uiCompAttrs.name}</Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                              value={uiCompAttrs.description} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={ uiCompTypeList ? (uiCompTypeList.find( ({ id }) => id === parseInt(uiCompAttrs.typeId) )).name : '' }
                      onSelect={onCompTypeSelect}>
                      {uiCompTypeList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                            {item.description}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col></Col>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_UiComp_name")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_UiComp_type")}:</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{uiCompAttrs.name}</Col>
                <Col>{uiCompAttrs.description}</Col>
                <Col>{ (uiCompTypeList.find( ({ id }) => id === parseInt(uiCompAttrs.typeId) )) ?
                       (uiCompTypeList.find( ({ id }) => id === parseInt(uiCompAttrs.typeId) )).name : '' }</Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{uiCompAttrs.creatorUsername}</Col>
                <Col>{formatDate(uiCompAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{uiCompAttrs.updaterUsername}</Col>
                <Col>{formatDate(uiCompAttrs.timeUpdated)}</Col>
              </Row>
            </Container>
          }

        </div>

{/* ##### FUTURE ENHANCEMENT - Can configure the UI compinent #####
        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Additional_attrs")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

              <Table hover responsive size="sm">
                <tbody>
                  {(Object.keys(typeSpecificAttrs)).map(renderTypeSpecificAttrs)}
                </tbody>
              </Table>

            </div>
            </form>
          </Container>
        </div>
*/}

{/*
        { uiCompAttrs && (uiCompAttrs.dataSrcStyle === 'FIXED') ?
          <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
            <div display='flex'>
              <span>
                {t("I18N_Data_selection")}
              </span>
            </div>
            <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Datapoint_codes")}: *</Col>
                </Row>
                  <Row className={classes.admin_pages__field_value}>
                  { editMode ?
                    <Col>
                      <input className={classes.admin_pages__field_editable} name="dataList" value={uiCompAttrs.dataList}
                        onChange={(e) => onAttrsInputChange(e)} />
                    </Col>
                  :
                    <Col>{uiCompAttrs.dataList}</Col>
                  }
                  </Row>

              </form>
            </Container>
          </div>
          :
          <></>
        }
*/}

{/* ##### FUTURE ENHANCEMENT - Can configure datapoints associated with the UI compinent #####
        { uiCompAttrs && (uiCompAttrs.dataSrcStyle === 'FIXED') ?

          <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
            <div display='flex'>
              <span>
                {t("I18N_Data_selection")}
              </span>
            </div>
            <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

            <Container>
              <form>

                <Table hover responsive size="sm" className={classes.admin_pages__field_value}>
                  <thead style={{borderBottom:"2px solid #D0D0D0"}}>
                    <tr>
                      <td>
                        <Row>
                          <Col><span style={{fontWeight:'400'}}>{t("I18N_Datapoint_code")}</span></Col>
                          <Col><span style={{fontWeight:'400'}}>{t("I18N_Description")}</span></Col>
                          <Col><span style={{fontWeight:'400'}}>{t("I18N_Color")}</span></Col>
                          <Col></Col>
                        </Row>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {dataObjList.map(renderDataObj)}
                  </tbody>
                </Table>

              </form>
            </Container>
          </div>
          :
          <></>
        }
*/}

        { editMode ?
          <div>
            <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{marginTop:'15px'}}>
                <Button size="tiny" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleEditCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="tiny" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleEditSubmit}>
                  {t("I18N_Save")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </div>
        :
          <></>
        }

        <hr className="solid" style={{ marginTop: '10px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize:'12px', fontWeight:'300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
{/*
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {updateUiCompErrMsg}
              </span>
*/}
            </div>
          </Form.Group>
        </div>

      </Card>
    </>
  );
}

export default UiCompAdminDetailsView;
